import { LoadingSpinner } from './LoadingSpinner';

/**
 * @group Components
 * @summary <blockquote>LoadingState component to wrap content that depends on async data.</blockquote>
 * @example
 * ```tsx
 * <LoadingState isLoading={isLoading} loadingText="Loading data...">
 *   <DataComponent />
 * </LoadingState>
 * ```
 */
export function LoadingState({ 
  children, 
  isLoading, 
  loadingText = "Loading...",
  className = ""
}: {
  children: React.ReactNode,
  isLoading: boolean,
  loadingText?: string,
  className?: string
}) {
  if (isLoading) {
    return (
      <div className={`flex flex-col items-center justify-center py-8 space-y-4 ${className}`}>
        <LoadingSpinner size="large" />
        <p className="text-muted-foreground">{loadingText}</p>
      </div>
    )
  }
  return <>{children}</>
} 